import type { RouteRecordRaw } from "vue-router";

const LimitOrderView = () => import("@views/app/limit-order/limit-order-view.vue");
const LimitOrderStartView = () => import("@views/app/limit-order/limit-order-start.vue");
const Step1View = () => import("@views/app/limit-order/step-1-view.vue");
const Step2View = () => import("@views/app/limit-order/step-2-view.vue");
const Step3View = () => import("@views/app/limit-order/step-3-view.vue");
const Step4View = () => import("@/app/views/app/limit-order/step-4-view.vue");
const Step5View = () => import("@/app/views/app/limit-order/step-5-view.vue");
const Step6View = () => import("@/app/views/app/limit-order/step-6-view.vue");
const LimitOrderEndView = () => import("@views/app/limit-order/limit-order-end-view.vue");

export const limitOrderRoutes: RouteRecordRaw[] = [
    {
        component: LimitOrderStartView,
        name: "LimitOrderStart",
        path: "limit-order/start/:reference?",
        props: true,
    },
    {
        component: LimitOrderView,
        name: "LimitOrder_home",
        path: "limit-order",
        children: [
            {
                component: Step1View,
                name: "LimitOrderStep1",
                path: "step-1/:id",
                props: true,
                meta: {
                    stepId: 1,
                    buttons: [
                        {
                            name: "Next",
                            action: "validateStep1",
                            label: "Next",
                            visible: true
                        }
                    ],
                    navigation: {
                        nextStep: "LimitOrderStep2",
                        end: "LimitOrderEnd"
                    }
                },
            },
            {
                component: Step2View,
                name: "LimitOrderStep2",
                path: "step-2/:id",
                props: true,
                meta: {
                    stepId: 2,
                    buttons: [{ name: "Next", action: "login", label: "Login", visible: true }],
                    navigation: {
                        precheck: "LimitOrderStep3",
                        installmentPlan: "LimitOrderStep5",
                        installmentPlanMulti: "LimitOrderStep5_Multi",
                        end: "LimitOrderEnd"
                    }
                }
            },
            {
                component: Step3View,
                name: "LimitOrderStep3",
                path: "step-3/:id",
                props: true,
                meta: {
                    stepId: 3,
                    buttons: [{ name: "Next", action: "executePrecheck", label: "Continue", visible: true }],
                    navigation: {
                        nextStep: "LimitOrderStep4",
                        end: "LimitOrderEnd"
                    }
                }
            },
            {
                component: Step4View,
                name: "LimitOrderStep4",
                props: true,
                path: "step-4/:id",
                meta: {
                    stepId: 4,
                    buttons: [{ name: "Next", action: "webNext", label: "Continue", visible: true }],
                    navigation: {
                        nextStep: "LimitOrderStep5",
                        end: "LimitOrderEnd"
                    }
                }
            },
            {
                component: Step5View,
                name: "LimitOrderStep5",
                path: "step-5/:id",
                props: true,
                meta: {
                    stepId: 5,
                    buttons: [{ name: "Next", action: "webNext", label: "Continue", visible: true }],
                    navigation: {
                        nextStep: "LimitOrderStep6",
                        end: "LimitOrderEnd"
                    }
                }
            },
            {
                component: Step6View,
                name: "LimitOrderStep6",
                path: "step-6/:id",
                props: true,
                meta: {
                    stepId: 6,
                    buttons: [{ name: "Next", action: "webNext", label: "CalculateLimit", visible: true }],
                    navigation: {
                        nextStep: "LimitOrderStep7",
                        end: "LimitOrderEnd"
                    }
                }
            },
            {
                component: LimitOrderEndView,
                name: "LimitOrderEnd",
                path: "end/:id",
                props: true,
                meta: {
                    buttons: [{ name: "BackToStore", action: "backToStore", visible: true }],
                    navigation: {}
                }
            },
            {
                name: "LimitRoot",
                path: "",
                redirect: {
                    name: "LimitOrderStart"
                }
            }
        ]
    }
];
